const SESSION_INVALID_STATUSES = [401, 403, 404];

export const isSessionInvalid = (payload: unknown): boolean => {
  const status = (payload as { status?: number | null } | null)?.status;
  return typeof status === "number" && SESSION_INVALID_STATUSES.includes(status);
};
